/**
 * A19 — Secteurs Spécialisés API client
 * Canonical mount: /api/comptabilite/specialized-sectors
 */
import { apiCall } from './api';

const BASE = '/comptabilite/specialized-sectors';

export const getSpecializedSectorTypes = async () => {
  const result = await apiCall(`${BASE}/types`);
  return result.data || [];
};

export const getSpecializedSectorData = async (sector, filters = {}) => {
  let endpoint = `${BASE}/${sector}`;
  const params = [];
  if (filters.fiscal_year_id) params.push(`fiscal_year_id=${filters.fiscal_year_id}`);
  if (filters.entity_id) params.push(`entity_id=${filters.entity_id}`);
  if (params.length) endpoint += `?${params.join('&')}`;
  const result = await apiCall(endpoint);
  return result.data || [];
};
